import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnbrSalesOrderConfirmationComponent } from './knbr-sales-order-confirmation/knbr-sales-order-confirmation.component';

@NgModule({
  declarations: [],
  imports: [CommonModule,
   ConfigModule.withConfig({
            cmsComponents: {
                OrderConfirmationFlexComponent: {
                    component: KnbrSalesOrderConfirmationComponent,
                }
            },
        } as CmsConfig),
        KnbrSalesOrderConfirmationComponent,
      ],
})
export class KnbrSalesOrderConfirmationModule {}
